module.exports = __webpack_public_path__ + "static/media/loading.dae39213.gif";